import React, { PropsWithChildren } from "react";

import { t } from "@lingui/core/macro";
import { TokenValues } from "@silversea-ssc/dotcom-read-model-types/Tokens";
import {
  BlockContentValue,
  ButtonsContainer,
  isBlockContentValuePresent,
  UnstyledBlockContent
} from "@silversea-ssc/ui-components-react";
import clsx from "clsx";
import Countdown from "components/Countdown/Countdown";
import { forceResTimezone } from "src/utils/date/forceResTimezone";
import * as styles from "./EmotionalHeroBannerContent.module.scss";

type Props = {
  title: BlockContentValue | string | undefined;
  content: BlockContentValue | undefined;
  ctaButtons: React.ReactNode | undefined;
  tokenValues?: TokenValues | undefined;
  bottomSpacing?: boolean;
  countdownDate?: Date;
  countdownLabel?: string;
  showCountdown?: boolean;
};

const EmotionalHeroBannerContent: React.FC<PropsWithChildren<Props>> = ({
  title,
  content,
  ctaButtons,
  tokenValues,
  children,
  bottomSpacing = false,
  countdownDate,
  countdownLabel,
  showCountdown = false
}) => {
  const isCountdownEnabled =
    showCountdown && !!countdownDate && countdownDate > new Date();

  return (
    <div className={styles.wrapper}>
      <h1 className={styles.title}>
        <UnstyledBlockContent value={title} tokens={tokenValues} />
      </h1>
      {isBlockContentValuePresent(content) && (
        <div className={styles.content}>
          <UnstyledBlockContent value={content} tokens={tokenValues} />
        </div>
      )}
      {ctaButtons && (
        <div
          className={clsx(styles.ctas, {
            [styles.bottomSpacing]: bottomSpacing
          })}
        >
          <ButtonsContainer align="center" mobileFullSize>
            {isCountdownEnabled && (
              <React.Suspense fallback={null}>
                <Countdown
                  expireDate={forceResTimezone(countdownDate)}
                  label={countdownLabel ?? t`OFFER ENDS IN`}
                />
              </React.Suspense>
            )}

            {ctaButtons}
          </ButtonsContainer>
        </div>
      )}
      {children && (
        <div className={styles.extraChildren}>
          <>{children}</>
        </div>
      )}
    </div>
  );
};

export default EmotionalHeroBannerContent;
